<template>
  <div id="page">
    <div class="progressGroup">
      <div class="progressItem">
        <div class="stepItem">
          <img class="stepItemImg" :src="step_1_img" />
          <div class="stepItemDesc">{{ step_1_desc }}</div>
        </div>
      </div>
      <div class="nextImgItem">
        <img class="nextImg" :src="step_1_next_img" />
      </div>

      <div class="progressItem">
        <div class="stepItem">
          <img class="stepItemImg" :src="step_2_img" />
          <div class="stepItemDesc">{{ step_2_desc }}</div>
        </div>
      </div>
      <div class="nextImgItem">
        <img class="nextImg" :src="step_2_next_img" />
      </div>

      <div class="progressItem">
        <div class="stepItem">
          <img class="stepItemImg" :src="step_3_img" />
          <div class="stepItemDesc">{{ step_3_desc }}</div>
        </div>
      </div>
      <!--  -->
      <div class="nextImgItem">
        <img class="nextImg" :src="step_3_next_img" />
      </div>

      <div class="progressItem">
        <div class="stepItem">
          <img class="stepItemImg" :src="step_4_img" />
          <div class="stepItemDesc">{{ step_4_desc }}</div>
        </div>
      </div>
    </div>
    <b-container>
      <div v-if="showReason">
        <hr />
        <p>
          抱歉您上传的卡面未通过审核。您可以在30天内“重新上传卡面”（无需再次缴费）或“取消订单”
        </p>
        <div>
          未通过原因：<span style="color: red">{{
            order.orderStatus == "审核未通过"
              ? "审核未通过（涉黄、涉暴、涉政等违规图片将无法审核通过）"
              : order.auditFailCause
          }}</span>
        </div>
      </div>
      <!-- <div v-if="showOrder"> -->
      <div>
        <hr />
        <div>
          订单编号：<span>{{ order.orderNo }}</span>
        </div>
        <hr />
        <div>
          卡片名称：<span>{{ order.cardTypeName }}</span>
        </div>
        <hr />
        <div>
          申请日期：<span>{{ order.orderDateTime }}</span>
        </div>
        <hr />
        <div v-if="ifOrder_ziti">
          <div>
            领卡网点：<span>{{ address_wangdian }}</span>
          </div>
          <div>
            领卡地点：<span>{{ address_wangdain_add }}</span>
          </div>
        </div>
        <div v-if="ifOrder_youji">
          邮寄地点：<span>{{ order.address }}</span>
        </div>
        <hr />
      </div>

      <div class="box" v-show="showReason">
        <div class="boxItem">
          <b-button block variant="outline-danger" @click="showCancelConfirm()"
            >取消订单</b-button
          >
        </div>
        <div class="boxItem">
          <b-button block variant="outline-primary" @click="reupload()"
            >重新上传卡面</b-button
          >
        </div>
      </div>

      <div class="box" v-show="showUnpayAction">
        <div class="boxItem">
          <b-button block variant="outline-danger" @click="showCancelConfirm()"
            >取消订单</b-button
          >
        </div>
        <div class="boxItem">
          <b-button block variant="outline-primary" @click="toOrderPay()"
            >订单支付</b-button
          >
        </div>
      </div>

      <b-modal
        ref="model_cancel_confirm"
        title="提示"
        @ok="handleCancelOrder"
        ok-title="取消"
        cancel-title="暂不取消"
      >
        <b-row>
          <b-col cols="10" class="mx-auto"> 确认取消订单？ </b-col>
        </b-row>
      </b-modal>

      <b-modal
        ok-only
        ref="model_cancel_result"
        title="提示"
        @ok="handeCancelResult"
        ok-title="确定"
      >
        {{ cancelResult }}
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "OrderDetails_hongcheng",
  data() {
    return {
      projectName: "",
      order: null,
      step_1_img: "static/hsbank/img_tijiao_hs.png",
      step_2_img: "static/hsbank/img_shenhe_hs.png",
      step_3_img: "static/hsbank/img_zhika_hs.png",
      step_4_img: "static/hsbank/img_youji_hs.png",
      step_1_next_img: "static/hsbank/img_next_hs.png",
      step_2_next_img: "static/hsbank/img_next_hs.png",
      step_3_next_img: "static/hsbank/img_next_hs.png",
      step_1_desc: "申请提交",
      step_2_desc: "正在审核",
      step_3_desc: "正在制卡",
      step_4_desc: "卡已邮寄",
      showReason: false,
      showOrder: false,
      showUnpayAction: false,
      cancelResult: "",
      ifOrder_ziti: true, //网点自提
      ifOrder_youji: false, //邮寄
      expressWay: "",
      address_wangdian: "", //领卡网点
      address_wangdain_add: "", //网点具体地址
    };
  },
  destroyed: function () {
    this.logout();
  },
  methods: {
    logout() {
      if (this.order.orderStatsNo == 1) {
        sessionStorage.clear();
        this.$router.push("Home_hongcheng");
      }
    },
    handeCancelResult: function () {
      this.$router.go(-1);
    },
    showCancelResult: function () {
      this.$refs["model_cancel_result"].show();
    },
    showCancelConfirm: function () {
      this.$refs["model_cancel_confirm"].show();
    },
    handleCancelOrder: function () {
      this.cancelOrder();
    },
    cancelOrder: function () {
      var that = this;
      axios
        .get(config.config_hongcheng.refund, {
          params: {
            orderNo: this.order.orderNo,
          },
        })
        .then(function (response) {
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
            // setTimeout(function() {
            //   that.$router.go(-3)
            // })
          } else {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
          }
          that.showCancelResult();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reupload: function () {
      var param = {
        isModify: 1,
        orderNo: this.order.orderNo,
        backgroundColor: this.order.backgroundColor,
        cardOri: this.order.modelClass,
        isPayed: true,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.replace({
        name: "SelectCardface_hongcheng",
        params: {
          selectParam: selectParam,
        },
      });
    },
    toOrderPay: function () {
      /* {
               orderNo: '01248790113566597120',
               orderDateTime: '2020-05-22 09:39:22',
               price: 1,
               projectName: 'DIY',
               thumbnailFileUrl: ''
             } */
      var obj = {
        orderNo: this.order.orderNo,
        orderDateTime: this.order.orderDateTime,
        price: this.order.price,
        projectName: this.projectName,
        thumbnailFileUrl: this.order.thumbnailFileUrl,
        bankCode: this.order.bankCode,
        isPayed: false,
        deadline: this.order.deadline, //支付截至日期
        cardTypeId: this.order.cardTypeId, //1-借记卡 / 2-信用卡
      };

      var orderInfo = JSON.stringify(obj);
      this.$router.replace({
        name: "OrderPay_hongcheng",
        params: {
          orderInfo: orderInfo,
        },
      });
    },
  },
  mounted: function () {
    /* {
        "projectName": "DIY",
        "order": {
          "orderNo": "01222404618637029376",
          "orderDateTime": "2020-03-10 14:12:50",
          "orderStatus": "制卡完成",
          "orderStatsNo": 8,
          "courierCompany": "",
          "trackNumber": "",
          "orderType": "1",
          "price": 1,
          "auditFailCause": null,
          "modelType": 0,
          "modelClass": 0,
          "backgroundColor": "201C",
          "cardClass": 1,
          "address": "北京市西城区新盛大厦B-8层",
          "orderStep": 3,
          "cardTypeName": "借记卡",
          "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png",

        }
      } */
    var orderItem = this.$route.params.orderItem;
    console.log("orderItem:" + orderItem);
    var orderItemObj = JSON.parse(orderItem);
    this.projectName = orderItemObj.projectName;
    this.order = orderItemObj.order;
    this.expressWay = orderItemObj.order.expressWay;
    var address = orderItemObj.order.address;
    this.address_wangdian = address.substring(0, 7);
    this.address_wangdain_add = address.substring(7, 100);

    if (this.expressWay == 1) {
      // 自提
      this.ifOrder_ziti = true;
      this.ifOrder_youji = false;
    } else if (this.expressWay == 2) {
      // 邮寄
      this.ifOrder_ziti = false;
      this.ifOrder_youji = true;
    }
    console.log("orderItemObj.order--->", orderItemObj.order);
    if (this.order != null) {
      switch (this.order.orderStep) {
        case 0:
        case 1:
          this.step_1_img = "static/hsbank/img_tijiao_hs_active.png";
          this.step_1_next_img = "static/hsbank/img_next_hs_active.png";
          break;
        case 2:
          this.step_1_img = "static/hsbank/img_tijiao_hs_active.png";
          this.step_1_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_2_img = "static/hsbank/img_shenhe_hs_active.png";
          this.step_2_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_2_desc = this.order.orderStatus;
          break;
        case 3:
          this.step_1_img = "static/hsbank/img_tijiao_hs_active.png";
          this.step_1_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_2_img = "static/hsbank/img_shenhe_hs_active.png";
          this.step_2_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_3_img = "static/hsbank/img_zhika_hs_active.png";
          this.step_3_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_2_desc = "审核通过";
          this.step_3_desc = this.order.orderStatus;
          break;
        case 4:
          this.step_1_img = "static/hsbank/img_tijiao_hs_active.png";
          this.step_1_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_2_img = "static/hsbank/img_shenhe_hs_active.png";
          this.step_2_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_3_img = "static/hsbank/img_zhika_hs_active.png";
          this.step_3_next_img = "static/hsbank/img_next_hs_active.png";
          this.step_4_img = "static/hsbank/img_youji_hs_active.png";
          this.step_2_desc = "审核通过";
          this.step_3_desc = "已制卡";
          break;
      }

      //审核未通过
      if (this.order.orderStep == 2 && this.order.orderStatsNo == 3) {
        this.showReason = true;
      } else {
        this.showReason = false;
      }
      //未支付
      if (this.order.orderStep == 0 && this.order.orderStatsNo == 5) {
        this.showUnpayAction = true;
      } else {
        this.showUnpayAction = false;
      }
    }
  },
};
</script>

<style scoped>
.box {
  margin-top: 8px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.boxItem {
  display: flex;
  flex: 1;
  margin: 8px;
}

.stepItem {
  display: flex;
  flex-direction: row;
}

.progressGroup {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  flex-wrap: nowrap;
  width: 100%;
  margin-top: 16px;
  padding-left: 8px;
  padding-right: 8px;
}

.progressItem {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 2;
  flex-shrink: 3;
}

.stepItem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.stepItemImg {
  width: 33px;
  height: 28px;
}

.stepItemDesc {
  font-size: 12px;
  margin-top: 8px;
}

.imgDiv {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.nextImgItem {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 1;
}

.nextImg {
  width: 33px;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/hongcheng/OrderDetails_hongcheng.vue